<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Categoria Prodotto</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="productCategoryFilterForm" (ngSubmit)="filter()" *ngIf="productCategoryFilterForm">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('ProductCategory.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="ProductCategory.id" min="1000" max="10000" >
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
                  Nome Categoria
                </h4>
                <span class="data">
                  <input type="text" formControlName="ProductCategory.categoryName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('ProductCategory.notes')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.notes')"></i>
                Notes
              </h4>
              <span class="data">
                <input type="text" formControlName="ProductCategory.notes" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i>
                </button>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                  RESET <i class="fas fa-times-circle"></i>
                </button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let productCategory of productCategories">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ productCategory?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Nome Categoria
                </h4>
                <div class="data">
                  <div>{{ productCategory?.categoryName || "---" }}</div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Notes
                </h4>
                <div class="data">
                  <div>{{ productCategory?.notes || "---" }}</div>
                </div>
            </div>

            <div class="item nowrap">
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" [routerLink]="['/product/categoria', productCategory?.id, 'edit']">MODIFICA</button>
                <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteProductCategory(productCategory?.id)">
                  Elimina<i class="ml-10 far fa-trash-alt"></i>
                </button>
              </span>
            </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Categoria Prodotto</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button routerLink="nuovo" class="btn btn-white vertical align-items-center">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="productCategoryFilterForm" (ngSubmit)="filter()" *ngIf="productCategoryFilterForm">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('ProductCategory.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="ProductCategory.id" min="1000" max="10000" >
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
                  Nome Categoria
                </h4>
                <span class="data">
                  <input type="text" formControlName="ProductCategory.categoryName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('ProductCategory.notes')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.notes')"></i>
                Notes
              </h4>
              <span class="data">
                <input type="text" formControlName="ProductCategory.notes" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i>
                </button>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                  RESET <i class="fas fa-times-circle"></i>
                </button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let productCategory of productCategories">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ productCategory?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Nome Categoria
                </h4>
                <div class="data">
                  <div>{{ productCategory?.categoryName || "---" }}</div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Notes
                </h4>
                <div class="data">
                  <div>{{ productCategory?.notes || "---" }}</div>
                </div>
            </div>

            <div class="item nowrap">
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" [routerLink]="['/product/categoria', productCategory?.id, 'edit']">MODIFICA</button>
                <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteProductCategory(productCategory?.id)">
                  Elimina<i class="ml-10 far fa-trash-alt"></i>
                </button>
              </span>
            </div>
        </div>
    </div>
</section>
-->

